import { render, staticRenderFns } from "./ListaDeProdutos.vue?vue&type=template&id=a51a96c2&scoped=true"
import script from "./ListaDeProdutos.vue?vue&type=script&lang=js"
export * from "./ListaDeProdutos.vue?vue&type=script&lang=js"
import style0 from "./ListaDeProdutos.vue?vue&type=style&index=0&id=a51a96c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51a96c2",
  null
  
)

export default component.exports